import { render, staticRenderFns } from "./DeclarationForm.vue?vue&type=template&id=6bbc1fec&scoped=true&"
import script from "./DeclarationForm.vue?vue&type=script&lang=ts&"
export * from "./DeclarationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc1fec",
  null
  
)

export default component.exports